// eslint-disable-next-line import/no-unresolved -- swiper/bundle is a valid package export; resolver doesn't follow package.json "exports"
import Swiper from "swiper/bundle";
import { observeElementInView } from "../vendor/inview-observer";

const $ = window.jQuery;

$(async function () {
    "use strict";

    const swiperElement = document.querySelector('.blogs-grid.swiper');

    if (!swiperElement) return;

    const swiper = new Swiper(swiperElement, {
        init: false, 
        autoHeight: false,
        pagination: { el: '.swiper-pagination' },
        navigation: {
            nextEl: '.blogs-grid .swiper-button-next',
            prevEl: '.blogs-grid .swiper-button-prev',
        },
        slidesPerView: 1.5,
        spaceBetween: 30,
        transition: 700,
        loop: true,
        breakpoints: {
            768: { slidesPerView: 3 },
            1336: { slidesPerView: 4 },
            1440: { slidesPerView: 4.3 },
            1600: { slidesPerView: 5 },
        },
    });

    // 3. Use the observer
    observeElementInView(swiperElement, () => {
        swiper.init();
    });
});